import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { REGIONS_GEOJSON } from '../../utils/constants';

const useRegions = () => {
    return useQuery({
        queryKey: ['regions'],
        queryFn: async () => {
            const { data } = await axios.get(
                `${process.env.REACT_APP_CLOUDFRONT_URL}/${REGIONS_GEOJSON}`
            );
            return data;
        },
        staleTime: 1000 * 60 * 60 * 24,
        refetchOnWindowFocus: false,
    });
};

export default useRegions;
